<div class="header">
  <div class="actions" *ngIf="media && !media.videoUrl">
    <mtg-share [url]="shareUrl"></mtg-share>
    <a (click)="download()">
      <mtg-svg-icon icon="icons-cloud-download"></mtg-svg-icon>
    </a>
  </div>
</div>

<div class="image" *ngIf="media">
  <mtg-button
    *ngIf="previousImage"
    color="secondary"
    variant="circle"
    class="left"
    (click)="openImage(previousImage)"
  ><mtg-svg-icon icon="icons-corner-left"></mtg-svg-icon></mtg-button>
  <mtg-spinner *ngIf="loading"></mtg-spinner>
  <img [src]="media.detailPhoto.path || media.originalPhoto.path" *ngIf="!media.videoUrl && !loading">
  <iframe
    *ngIf="media.videoUrl && !loading"
    [src]="media.videoUrl | safe: 'resourceUrl'"
    frameborder="0"
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
  ></iframe>
  <mtg-button
    *ngIf="nextImage"
    color="secondary"
    variant="circle"
    class="right"
    (click)="openImage(nextImage)"
  ><mtg-svg-icon icon="icons-corner-right"></mtg-svg-icon></mtg-button>
</div>

<div class="footer">
  <mtg-button color="secondary" variant="circle" (click)="toggleFullScreen()" class="fullscreen-btn">
    <mtg-svg-icon icon="icons-full-screen" *ngIf="!isFullScreen"></mtg-svg-icon>
    <mtg-svg-icon icon="icons-full-screen-off" *ngIf="isFullScreen"></mtg-svg-icon>
  </mtg-button>
</div>
